





























































import debounce from 'lodash.debounce';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { FormField } from '../models/form';

@Component({})
export default class DynamicFormFieldComponent extends Vue {
  @Prop({ required: true })
  field!: FormField;

  search: () => void = null;

  get rules() {
    const validationRules: Record<string, string> = {
      email: `${this.field.validations}|email`,
    };

    return validationRules[this.field.id] || this.field.validations;
  }

  fieldChange() {
    if (!this.field.allowSearch || !this.field.value) {
      return;
    }

    this.search =
      this.search ||
      debounce(() => {
        const obj: any = {};

        obj[this.field.name] = this.field.value;

        return this.$emit('on-search', obj);
      }, 500);
    this.search();
  }
}
